import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field, FieldArray, ErrorMessage, getIn } from 'formik'
import axios from 'axios'
import moment from 'moment'
import useOnclickOutside from "react-cool-onclickoutside"
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../../services/redirect'
import Spinner from '../../../../services/spinner'
import AlertMessage from '../../../../services/alert'


import { ValidateAddEmails } from '../../../../validations/schemaReports'

export default function AddEmail(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*----------------------------------------
    FORM STATE DATA
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }

  const [state, setstate] = useState({
    status:1,
    emails:[{
      email:''
    }]
  });



  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','addEmails');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/reports/processed-orders/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        props.resetForm();
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Emails successfully saved.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
          CallbackModal({close:true,reload:true});
        },2000);
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  /*----------------------------------------
    GET EMAILS
  -----------------------------------------*/
  function handleGetEmails(status){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','getEmails');
    formData.append('status',status);
    axios.post('/admin/reports/processed-orders/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      if(obj.length>0){
        setstate({
          ...state,
          status:status,
          emails:obj
        });
      }
      
      setspinner(false);


    })
    .catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }




  useEffect(()=>{
    handleGetEmails(1);
  },[]);


  return (
    <React.Fragment>

    <Formik
        enableReinitialize
        initialValues={state}
        validationSchema={ValidateAddEmails}
        onSubmit={handleSubmitForm}
        render={formProps => {
        const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

        return(
           <Form>
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small center animate__animated animate__slideInUp animate__faster" ref={handleClickAway}>

              {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
              {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}


              {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div>
                      <h2>Email Addresses</h2>
                    </div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                        <div class="alert-message left info infohasborder">
                          <div><i class="info circle icon"></i></div>
                          <div>
                            <p>Enter email addresses that can receive weekly processed order reports.</p>
                          </div>
                        </div>

                        <br/>

          
                        <FieldArray
                          name="emails"
                          render={arrayHelpers => (
                            <div>
                              {values.emails.map((variation, index) => (
                                <div key={index}>

                                    <Form.Group widths="equal">
                                      <Field name={`emails[${index}].email`}>
                                          {({ field, form }) => (

                                          <Form.Field required className={(() => {return getIn(form.errors, `emails.${index}.email`) && getIn(form.touched, `emails.${index}.email`) ? 'error' : "";})()}>
                                            <label style={{'position':'relative'}}>Email 
                                            {index>0&&<span style={{'position':'absolute','right':'0', 'cursor':'pointer'}} onClick={() => arrayHelpers.remove(index)}><i className="close icon" style={{'color':'#e41e2e'}}></i></span>}
                                            </label>
                                            <Input {...field} onChange={handleChange}/>
                                            { getIn(form.touched, `emails.${index}.email`) && getIn(form.errors, `emails.${index}.email`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `emails.${index}.email`)}</Label> }
                                          </Form.Field>
                                          )}
                                      </Field>
                                    </Form.Group>

                                </div>
                                ))}
                              <Button className='GreenButton strong' size='tiny' content='Add Email'  icon='uil-plus icon' onClick={() => arrayHelpers.push({
                                  email:'',
                                }
                              )}/>

                          </div>
                          )}/>


                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer">
                     <Button disabled={!(isValid&&dirty)} size="large" fluid className='BlueButton strong' content='SAVE EMAILS' onClick={() => buttonSubmit(1)}/>
                     <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                 </div>



              </div>{/*.modalpanel-container*/}
            </div>
          </Form>
        )}}/>
    </React.Fragment>
  )
}
